import { applySheets } from "../../../app/utils/styleCache.js";
import "../../shared/app-pagination/app-pagination.js";

export class AppTable extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.isMounted = false;
    }

    connectedCallback() {
        this.shadowRoot.innerHTML = `
            <style>
                :host { display: flex; flex-direction: column; flex: 1 1 auto; width: 100%; max-height: 100%; min-height: 0; opacity: 0; }
                #table { min-height: 0; width: 100%; }
                #pagination { margin-top: auto; }
            </style>
            <div id="table"></div>
            <app-pagination id="pagination"></app-pagination>
        `;

        this.isMounted = true;

        this.ready = applySheets(this.shadowRoot, [
            "components/features/app-table/style/tabulator.css",
            "components/features/app-table/style/customTabulator.css",
        ]).then(() => new Promise(resolve => requestAnimationFrame(resolve)));
    }
}

customElements.define("app-table", AppTable);
